"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const differenceWith_1 = __importDefault(require("lodash/differenceWith"));
const intersectionWith_1 = __importDefault(require("lodash/intersectionWith"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const DefaultClassUtil_1 = __importDefault(require("./DefaultClassUtil"));
class ClassServiceUtil {
    constructor() {
        this.hasNewSelectedOffers = (currentSelectedOffers, prevSelectedOffers) => {
            return (0, differenceWith_1.default)(currentSelectedOffers, prevSelectedOffers, (offer1, offer2) => offer1 === offer2).length;
        };
    }
    buildClass(formData, defaultClass, id) {
        const objectClass = {
            name: formData.name,
            defaultClass,
            offers: this.parseOfferKeysToObjectList(formData.offersCheckList)
        };
        if (id) {
            objectClass.id = id;
        }
        return objectClass;
    }
    buildFilters(params) {
        const { classId, searchText, userType } = params.filters;
        const filters = [];
        if (classId) {
            filters.push({ _type: 'user_class', ids: [classId] });
        }
        if (searchText) {
            filters.push({ _type: 'simple', query: searchText });
        }
        if (userType) {
            filters.push({ _type: 'user_type', query: userType.value });
        }
        return filters;
    }
    parseOfferKeysToObjectList(selectedOffers = []) {
        return selectedOffers.map((offer) => {
            return { offerKey: offer };
        });
    }
    filterOffersCurrentlyOnTheMarketplace(selectedOffers, membershipOffers) {
        const availableOffers = (0, intersectionWith_1.default)(selectedOffers, membershipOffers, this.isOfferMatch);
        return availableOffers.map((offer) => offer.offerKey);
    }
    isOfferMatch(selectedOffer, offerToCompare) {
        const selectedOfferKey = selectedOffer && selectedOffer.offerKey;
        const offerKey = offerToCompare && offerToCompare.key;
        return (!(0, isEmpty_1.default)(selectedOffer) &&
            !(0, isEmpty_1.default)(offerKey) &&
            selectedOfferKey === offerKey);
    }
    parseRelatedOffersToMap(classesRelatedOffers = []) {
        const relatedOffersMap = new Map();
        classesRelatedOffers.forEach((item) => {
            if (item.offers.length) {
                item.offers.forEach((offer) => relatedOffersMap.set(offer.offerKey, item.name));
            }
            else {
                relatedOffersMap.set('defaultClass', DefaultClassUtil_1.default.appendMarkToName(item.name));
            }
        });
        return relatedOffersMap;
    }
    parseTotalUsersListToMap(totalUsersList = []) {
        const totalUsersMap = new Map();
        if (totalUsersList) {
            totalUsersList.forEach((item) => {
                totalUsersMap.set(item.classId, item.totalUsers);
            });
        }
        return totalUsersMap;
    }
}
exports.default = new ClassServiceUtil();
